
import { computed, defineComponent, reactive, ref, Ref, defineAsyncComponent } from "vue";
import SignupForm from "@/components/signup/SignupForm";
import InputText from "@/components/primevueCustom/InputText.vue";
import Button from "primevue/button";
import { Field, Form, ErrorMessage } from "vee-validate";
import PageFrame from "@/components/common/PageFrame.vue";
import { useI18n } from "vue-i18n";
import { useStore } from "@/store";
import Checkbox from "primevue/checkbox";
import locales from "@/utils/Locales";

// import { onBeforeRouteLeave } from "vue-router";

const enum InnerPages {
  PRIVACYPOLICY,
  INPUTS,
}

export default defineComponent({
  name: "Signup",
  setup() {
    const { t, locale } = useI18n();
    const state = reactive({
      step: InnerPages.PRIVACYPOLICY,
      isPossibleEmail: false,
      isPossibleEmailButton: false,
    });

    const signupPrivacyPolicyContentKO = defineAsyncComponent(() =>
      import("@/components/signup/privacyContents/ko.vue")
    );
    const signupPrivacyPolicyContentJA = defineAsyncComponent(() =>
      import("@/components/signup/privacyContents/ja.vue")
    );
    const signupPrivacyPolicyContentEN = defineAsyncComponent(() =>
      import("@/components/signup/privacyContents/en.vue")
    );
    const signupPrivacyPolicyContentUZ = defineAsyncComponent(() =>
      import("@/components/signup/privacyContents/uz.vue")
    );
    const signupPrivacyPolicyContentRU = defineAsyncComponent(() =>
      import("@/components/signup/privacyContents/ru.vue")
    );

    const agreeAll = ref(false);

    const store = useStore();

    console.log(locale.value, "locale.value");

    const cookieLocale = locales.initLocale();
    console.log(cookieLocale, "cookieLocale");

    const privacyPolicyContent = locales.isKorean(cookieLocale)
      ? signupPrivacyPolicyContentKO
      : locales.isJapanese(cookieLocale)
      ? signupPrivacyPolicyContentJA
      : locales.isUzbek(cookieLocale)
      ? signupPrivacyPolicyContentUZ
      : locales.isRussian(cookieLocale)
      ? signupPrivacyPolicyContentRU
      : signupPrivacyPolicyContentEN;

    const signupForm = SignupForm;

    const signupForm$: Ref<SignupForm | null> = ref(null);

    const nextStep = () => {
      state.step += 1;
    };

    const isPrivacyPolicy = computed(() => state.step === InnerPages.PRIVACYPOLICY);

    const isValidSignupData = ref(false);
    const isValidSignupFormData = computed(() => {
      return isValidSignupData.value;
    });

    // /**
    //  * 뒤로가기 시 가입화면이면 동의 화면으로 이동
    //  */
    // onBeforeRouteLeave((to, from, next) => {
    //   if (state.step > InnerPages.PRIVACYPOLICY) {
    //     state.step = InnerPages.PRIVACYPOLICY;
    //     agreeAll.value = false;
    //     next(false);
    //   } else next();
    // });

    return {
      state,
      alert,
      t,
      privacyPolicyContent,
      store,
      nextStep,
      agreeAll,
      signupForm,
      isPrivacyPolicy,
      isValidSignupData,
      isValidSignupFormData,
      signupForm$,
    };
  },
  methods: {
    submit() {
      this.signupForm$?.signup();
    },

    onFormStatus(valid: boolean) {
      console.log("onFormStatus=>", valid);

      this.isValidSignupData = valid;
    },
  },

  components: {
    InputText,
    Button,
    Field,
    Form,
    ErrorMessage,
    PageFrame,
    Checkbox,
  },
});
